import { render } from "./Features.vue?vue&type=template&id=629093da&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=629093da&lang=less&scoped=true"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629093da"]])

export default __exports__